export const state = () => {
  return {
    changeEpisodeHistory: [],
    isClickPlay: false,
    newSeries: false
  }
}

export const mutations = {
  SET_EPISODEHISTORY(state, history) {
    state.changeEpisodeHistory.push(history)
  },
  SET_ISCLICKPLAY(state, val) {
    state.isClickPlay = val
  },
  SET_NEWSERIES(state, val) {
    state.newSeries = val
  },
  CLEAN_EPISODEHISTORY(state) {
    state.changeEpisodeHistory = []
  }
}
